module.exports = __webpack_public_path__ + "img/contact.144dc8de.png";